import { useCallback } from 'react'
import { selectIsUserConnected } from '../../../store/userAccount/userAccount.selectors'
import { useSelector } from 'react-redux'
import { TAG_HOME_WORK } from '../../analytics/analytics.tagids.constants'

const useFavoritePushTagBuilder = () => {
  const isUserConnected = useSelector(selectIsUserConnected)

  const favoritePushTabBuilder = useCallback(
    suggest => {
      const { type, incentive } = suggest
      return { type: TAG_HOME_WORK, tagInfo: { type, isFavoriteFilled: !incentive, isUserConnected } }
    },
    [isUserConnected]
  )

  return { favoritePushTabBuilder }
}

export default useFavoritePushTagBuilder
